export const chatbotConstants = {
  CHATMESSAGES: 'CHATMESSAGES',
};
